import * as ActionTypes from "./actionTypes";

export const getNotifications = () => ({
    type: ActionTypes.GET_NOTIFICATION
  });
  
  export const notificationResponse = data => ({
    type: ActionTypes.NOTIFICATION_RESPONSE,
    data
  });